module.exports = kolibriCoreAppGlobal.coreVue.mixins.responsiveElementMixin;